import {
  CART_RECEIVE,
  CART_SHOW_INFO,
  CART_SHOW_MINI_CART,
  CART_UPDATE_ADDITIONAL_INFO,
} from '../constants';

export const cart = (
  state = {
    quantity: 0,
    orderTotal: 0,
    showInfo: false,
    showMiniCart: false,
    grandTotal: '',
  },
  action
) => {
  switch (action.type) {
    case CART_RECEIVE:
    case CART_SHOW_INFO:    
    case CART_SHOW_MINI_CART:
      return {
        ...state,
        ...action.payload,
      };
      case CART_UPDATE_ADDITIONAL_INFO:
        return {
          ...state,
          orderRows: state.orderRows.map((row) =>
            row.rowSystemId === action.payload.rowSystemId
              ? {
                  ...row,
                  addTestCertificate: action.payload.addTestCertificate,
                }
              : row
          ),
        }; 
    default:
      return state;
  }
};
